export default "__VITE_ASSET__Dg__B92P__"